import { render, staticRenderFns } from "./MorrisDonutChart.vue?vue&type=template&id=66e8343a"
import script from "./MorrisDonutChart.vue?vue&type=script&lang=js"
export * from "./MorrisDonutChart.vue?vue&type=script&lang=js"
import style0 from "./MorrisDonutChart.vue?vue&type=style&index=0&id=66e8343a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports